import React from 'react'
import "./How_It_works.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import How_It_works_card from './How_It_works_card/How_It_works_card'
import Common_title from '../../common/common-title/Common_title';

function How_It_works() {
    return (
        <>
            <section className='How_It_works margin_section'>
                <div className="container">
                   <Common_title headingText="How It Works"/>

                    <div className='How_It_works_swiper_holder'>
                        <div className='pencil_circle_holder'>
                            <img src="/assets/images/home/how-it-works/pencil_circle.png" alt="pencil circle" className='pencil_circle' />
                        </div>
                        <Swiper
                            spaceBetween={80}
                            slidesPerView={1.5}
                            className="How_It_works_swiper"
                            loop
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                576: {
                                    slidesPerView: 1.3,
                                    spaceBetween: 30,
                                },
                                768: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 40,
                                },
                                992: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 50,
                                },
                                1200: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 60,
                                },
                                1400: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 80,
                                },
                            }}
                        >
                            <SwiperSlide>
                                <How_It_works_card
                                    number={"1"}
                                    heading={"Login with your ID & Password"}
                                    text={"Securely sign in to your account to access rent and bill payment features."}
                                />
                            </SwiperSlide>

                            <SwiperSlide>
                                <How_It_works_card
                                    number={"2"}
                                    heading={"Get reminders and upload bills"}
                                    text={"Receive timely alerts for rent and electricity dues. Upload your electricity bill photo and enter meter readings with ease."}
                                />
                            </SwiperSlide>

                            <SwiperSlide>
                                <How_It_works_card
                                    number={"3"}
                                    heading={"Pay securely in just one tap"}
                                    text={"Receive timely alerts for rent and electricity dues. Upload your electricity bill photo and enter meter readings with ease."}
                                />
                            </SwiperSlide>
                        </Swiper>
                    </div>

                </div>
            </section>
        </>
    )
}

export default How_It_works